import FilterBody from './FilterBody';
import Popover from '../Popover';
import {translate} from '../../utils';
import {filtersMap} from './FiltersUtils';
import {useRef} from 'react';

const SUGGESTED_CHIP_APPEARANCE_CLASS = {
    default: 'btn-default',
    defaultClear: 'btn-default-clear',
};

export default function FilterChip({variant, label, fieldSchema, applyFilter, internalOperators, appearance}) {
    if (variant === 'suggested') {
        return <SuggestedFilterChip label={label} fieldSchema={fieldSchema} applyFilter={applyFilter} internalOperators={internalOperators} appearance={appearance}/>;
    } else if (variant === 'active') {
        return <ActiveFilterChip label={label} fieldSchema={fieldSchema} applyFilter={applyFilter} internalOperators={internalOperators}/>;
    }
}

function SuggestedFilterChip({label, fieldSchema, applyFilter: ogApplyFilter, internalOperators, appearance}) {
    const popoverRef = useRef();

    function applyFilter(newFilter) {
        ogApplyFilter(newFilter);
        popoverRef.current.hide();
    }

    return <Popover ref={popoverRef} title={translate('frontend', 'FILTER_SELECTION_BY_PARAM', {param: label})} content={<FilterBody fieldSchema={fieldSchema} applyFilter={applyFilter} internalOperators={internalOperators}/>}>
        <button type="button" className={`btn ${SUGGESTED_CHIP_APPEARANCE_CLASS[appearance]}`}>
            {label} <i className="fa fa-angle-down"></i>
        </button>
    </Popover>;
}

function ActiveFilterChip({label, fieldSchema, applyFilter: ogApplyFilter, internalOperators}) {
    const popoverRef = useRef();
    function clearFilter() {
        ogApplyFilter(null);
    }

    function applyFilter(newFilter) {
        ogApplyFilter(newFilter);
        popoverRef.current.hide();
    }

    const displayValue = transformToDisplayValue(fieldSchema, internalOperators);

    return <div className="btn-group">
        <button type="button" className="btn btn-primary" onClick={clearFilter}>
            <i className="fa fa-times"></i>
        </button>
        <Popover ref={popoverRef} title={translate('frontend', 'FILTER_SELECTION_BY_PARAM', {param: label})} content={<FilterBody fieldSchema={fieldSchema} applyFilter={applyFilter} internalOperators={internalOperators}/>}>
            <button type="button" className="btn btn-primary">{label}: {displayValue}</button>
        </Popover>
    </div>;
}

function transformToDisplayValue(fieldSchema, internalOperators) {
    const displayValue = fieldSchema.type in filtersMap ? filtersMap[fieldSchema.type].filterOptions.displayValue(internalOperators, fieldSchema) : undefined;

    return typeof displayValue === 'undefined' ? 'unknown' : displayValue;
}
